// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"3b80a847","867":"e4aba5a2"}[chunkId] + ".chunk.js";
};